import React, { FunctionComponent } from 'react';
import styles from './dtp-stock-badge-component.module.scss';
import { ILabel } from '../../../models/common/label.model';
import { IStock, StockStatus } from '../../../models/common/stock.model';
import { Badge } from 'rs-emd-ui-atoms';
import { IconName } from 'rs-emd-ui-atoms/dist/components/icons/icon/icon-component';

export type DTPStockBadge = {
  labels?: ILabel[] | null;
  stockArea?: IStock | null;
  className?: string;
};

export const DTPStockBadge: FunctionComponent<DTPStockBadge> = (props: DTPStockBadge) => {
  return (
    <div className={`${styles['dtp-stock-badge-container']} ${props.className}`}>
      <Badge
        colour={
          props.stockArea?.statusCode === StockStatus.Error || props.stockArea?.statusCode === StockStatus.StatusUnavailable
            ? 'mono'
            : 'purple'
        }
        size='small'
        icon={props.stockArea?.stockBadgeIcon as IconName}>
        {props.stockArea?.title && <p className={styles['stock-title']} dangerouslySetInnerHTML={{ __html: props.stockArea?.title }} />}
      </Badge>
    </div>
  );
};

DTPStockBadge.defaultProps = {};

export default DTPStockBadge;
